import React from 'react';
import { TooltipComponent } from 'src/common/tooltip/component';
import { ChevronDownRegularIcon, ChevronUpRegularIcon } from 'src/monet/icons';

export type TableSortableColumnHeaderOrderType = 'asc' | 'desc';

export type TableSortableColumnHeaderSortType<T> = {
  sortName: T;
  orderBy: TableSortableColumnHeaderOrderType;
};

interface TableSortableHeaderProps<T> {
  title: string | JSX.Element;
  tooltip?: string | JSX.Element;
  className?: string;
  activeOrderType: TableSortableColumnHeaderOrderType;
  isActive: boolean;
  accessor: T;
  onClick: (stack: TableSortableColumnHeaderSortType<T>) => void;
}

export const INITIAL_ORDER_BY_FOR_HEADER = 'desc';

function getNewOrderBy(isActive: boolean, activeOrderType: TableSortableColumnHeaderOrderType) {
  if (isActive) {
    return activeOrderType === 'asc' ? 'desc' : 'asc';
  } else {
    return INITIAL_ORDER_BY_FOR_HEADER;
  }
}

export const TableSortableColumnHeader = <T,>({
  title,
  tooltip,
  isActive,
  activeOrderType,
  className,
  accessor,
  onClick,
}: TableSortableHeaderProps<T>) => {
  const onClickHeader = () => {
    onClick({
      sortName: accessor,
      orderBy: getNewOrderBy(isActive, activeOrderType),
    });
  };

  const content = (
    <div
      className='flex items-center justify-start transition-opacity hover:opacity-80 cursor-pointer space-x-1'
      onClick={onClickHeader}
    >
      {typeof title === 'string' ? <span className={className}>{title}</span> : title}
      {isActive && activeOrderType && (
        <span>
          {activeOrderType === 'asc' ? (
            <ChevronUpRegularIcon className='shrink-0' />
          ) : (
            <ChevronDownRegularIcon className='shrink-0' />
          )}
        </span>
      )}
    </div>
  );

  return tooltip ? (
    <div className='flex'>
      <TooltipComponent placement='top' tooltipContent={tooltip} styling='tooltip' theme='journey'>
        {content}
      </TooltipComponent>
    </div>
  ) : (
    content
  );
};
